module.exports = __webpack_public_path__ + "img/honnor1.e432ba09.png";